module.exports = __webpack_public_path__ + "static/media/9DESA7.2d6b7a7b.jpg";